import React from 'react';
import Navbar from './component/navbar/Navbar';
import "./App.css"
import Banner from './component/banner/Banner';
import Rowpost from './component/rowpost/Rowpost';
import {orginals,action} from './Url'

function App() {
  return <div>
    <Navbar/>
    <Banner/>
    <Rowpost url={orginals} title='Netflix Orginals' />
    <Rowpost url={action} title='Action Movies' isSmall/>
  </div>;
}

export default App;
